import axios from 'axios';
import authHeader from './auth-header';

const config = require("../config/config.js");

const API_URL = config.API_URL + 'balance/';

class BalanceService {
  sendBalance(data) {
    return axios
      .post(API_URL + 'send', data, { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }
  getBalances() {
    return axios
      .get(API_URL + 'listbalances', { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }
  getBalancesFiltered(data) {
    return axios
      .post(API_URL + 'listbalancesfiltered', data,{ headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }
}

export default new BalanceService();
